/** Textos ES/EN del asistente de alta (introducción del usuario recién registrado). */
export const INTRO_COPY = {
  es: {
    stepOf: "Paso {s} de 4",
    preview: "Vista previa · no se guarda nada",
    back: "Atrás",
    continue: "Continuar",
    seeAssessment: "Ver mi primera valoración",
    enterPanel: "Acceder al panel",
    closePreview: "Cerrar",
    s1Title: "¿Quién eres?",
    s1Sub: "Con esto ajustamos el lenguaje. Si el rol aún no está claro, no pasa nada.",
    firstName: "Nombre",
    lastName: "Apellidos",
    roleLabel: "Tu rol",
    roleUnknown: "Aún no lo tengo claro",
    s2Title: "Tu negocio",
    s2Sub: "Si la marca, el sector o la web aún no existen, lo vemos más adelante.",
    brand: "Marca",
    brandPh: "Nombre de tu marca o tienda",
    noBrand: "Aún no tengo nombre",
    sector: "Sector",
    sectorUnknown: "Aún no lo tengo definido",
    web: "Página web",
    webPh: "www.tutienda.com",
    noWeb: "Aún no tengo página web",
    s3Title: "Cómo está montado",
    s3Sub: "Si no sabes el régimen o aún no tienes local, lo dejamos pendiente y te ayudamos a aclararlo.",
    fiscal: "Estructura fiscal",
    notRegistered: "Todavía no estoy dado de alta",
    unknown: "Aún no lo sé",
    locations: "Locales",
    s4Title: "¿En qué te gustaría centrarte ahora?",
    s4Sub: "Elige hasta 2 con los que te identifiques. Si prefieres ir paso a paso, te acompañamos desde el principio.",
    challengeUnknown: "Prefiero ir paso a paso, con acompañamiento",
    language: "Idioma de emails y panel",
    aTitle: "Tu primera valoración",
    aLoading: "El Agente Retail IA está leyendo tu negocio…",
    aError: "No hemos podido preparar tu valoración. Tu acceso sigue protegido hasta que esté lista.",
    aRetry: "Volver a intentarlo",
    aStepsTitle: "Tres pasos para empezar",
    aHelpTitle: "Te ayudamos con",
    aClosing: "A partir de aquí trabajamos contigo para ordenar el negocio y mejorarlo. No hace falta tenerlo todo resuelto.",
    errSave: "No hemos podido guardar este paso. Inténtalo de nuevo.",
    pendingTitle: "Te ayudamos a cerrar lo que falta",
    pendingCta: "Completar en Mi Perfil",
    pending: {
      role: "Tu rol en el negocio",
      brand: "El nombre de la marca",
      sector: "El sector",
      website: "La página web",
      fiscal: "La estructura fiscal",
      locations: "Los locales",
      challenge: "En qué centrarnos",
    } as Record<string, string>,
  },
  en: {
    stepOf: "Step {s} of 4",
    preview: "Preview · nothing is saved",
    back: "Back",
    continue: "Continue",
    seeAssessment: "See my first assessment",
    enterPanel: "Access my panel",
    closePreview: "Close",
    s1Title: "Who are you?",
    s1Sub: "This helps us adjust the language. If your role isn't clear yet, that's fine.",
    firstName: "First name",
    lastName: "Last name",
    roleLabel: "Your role",
    roleUnknown: "Not clear yet",
    s2Title: "Your business",
    s2Sub: "If the brand, sector or website don't exist yet, we'll look at it later.",
    brand: "Brand",
    brandPh: "Your brand or shop name",
    noBrand: "I don't have a name yet",
    sector: "Sector",
    sectorUnknown: "Not defined yet",
    web: "Website",
    webPh: "www.tutienda.com",
    noWeb: "I don't have a website yet",
    s3Title: "How it's set up",
    s3Sub: "If you don't know your tax regime or don't have premises yet, we'll leave it pending and help you sort it out.",
    fiscal: "Tax structure",
    notRegistered: "I'm not registered yet",
    unknown: "I don't know yet",
    locations: "Locations",
    s4Title: "What would you like to focus on now?",
    s4Sub: "Choose up to 2 that feel familiar. If you prefer to take it step by step, we'll guide you from the start.",
    challengeUnknown: "I'd rather take it step by step, with guidance",
    language: "Email and panel language",
    aTitle: "Your first assessment",
    aLoading: "The Retail AI Agent is reading your business…",
    aError: "We couldn't prepare your assessment. Your access stays protected until it is ready.",
    aRetry: "Try again",
    aStepsTitle: "Three steps to get started",
    aHelpTitle: "We'll help you with",
    aClosing: "From here on we work with you to organise and improve the business. You don't need to have it all figured out.",
    errSave: "We couldn't save this step. Please try again.",
    pendingTitle: "We'll help you close what's missing",
    pendingCta: "Complete in My Profile",
    pending: {
      role: "Your role in the business",
      brand: "The brand name",
      sector: "The sector",
      website: "The website",
      fiscal: "The tax structure",
      locations: "The locations",
      challenge: "What to focus on",
    } as Record<string, string>,
  },
} as const;
